// extracted by mini-css-extract-plugin
export default {"wrapper":"BreadCrumb_wrapper__3DlBE","backButton":"BreadCrumb_backButton__5vsKM","cancelButton":"BreadCrumb_cancelButton__YgXlP","rejectButton":"BreadCrumb_rejectButton__FDdy6"};